import React from 'react';
// import emptyFolderImage from '../../assets/images/EmptyFolder.png'; // Replace with your image path
import FolderIcon from '@mui/icons-material/Folder';

function EmptyFolder() {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center', // Center horizontally
      justifyContent: 'center', // Center vertically
      height: '50vh', // Make it cover the entire viewport height
    }}>
      <div><FolderIcon style={{ color: 'rgb(252 227 156)', fontSize: 96 }} /></div>
      <div style={{fontSize :18, fontWeight: 500}}>This folder is empty</div>
    </div>
  );
}

export default EmptyFolder;
